import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import TextField from '@material-ui/core/TextField';
import $ from "jquery";
import Server from '../../functions/server';
import Loading from '../loading';

class DeletePurchaser extends React.Component {
  state = {
    name: '',
    error: '',
    load: false,
    message: '',
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  submit() {
    let context = this;
    let id = this.props.deleteid;
    context.setState({
      load: true,
      message: 'Add Purchaser!!!'
    })
    let data1 = { 'id': id }
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchaser/deletepurchaser.php',
      success: function(data)
      {
        console.log(data);
        context.setState({
          load: false,
        });
        if (data == 1) {
          context.props.getPurchaser();
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false,
        });
      }
    });
  }

  render() {
    const { fullScreen } = this.props;
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Dialog
          fullScreen={fullScreen}
          open={this.props.deletePurchaser}
          onClose={this.props.handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">{"Delete Purchaser"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Do you want to remove it!!!
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.handleClose} color="secoundary">
              Cancel
            </Button>
            <Button onClick={this.submit.bind(this)} color="primary" autoFocus>
              Add
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

DeletePurchaser.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(DeletePurchaser);
